<template>
  <div class=" bg-white rounded-lg shadow">
    <h2 class="flex justify-start text-primary-500 font-bold">
      Here's Whats New!
    </h2>
    <hr class="border-2 border-primary-500 items-center">
    <div class="flex flex-col justify-between py-3 -mx-2">
      <div class="w-full mb-6 px-3">
        <div class="rounded overflow-hidden  flex flex-col justify-between bg-white">
          <div class="flex h-15 justify-start w-full">
              <div class="px-6 py-4">
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.56.0</strong> - 7/26/2024
                      </p>
                      <ul>
                          <li>Changed "todo" to "task" throughout the platform.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.54.0</strong> - 3/2/2023
                      </p>
                      <ul>
                          <li>Added a feature that allows groups to be archived.</li>
                          <li>Users are now sorted alphabetically by their last name.</li>
                          <li>Users can now be selected on the Admin Users and Groups pages and their assignment statuses will be displayed.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.53.0</strong> - 6/8/2022
                      </p>
                      <ul>
                          <li>Adjusted the Mentoring Gateway page to be more clear and show aditional information.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.52.0</strong> - 4/13/2022
                      </p>
                      <ul>
                          <li>Now setting different default tabs on 'My Assignments' based on user role.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.51.0</strong> - 2/16/2022
                      </p>
                      <ul>
                          <li>Added option to set assignment reviewers to mentors' consultants.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.50.0</strong> - 1/31/2022
                      </p>
                      <ul>
                          <li>Notification senders will now be CC'd on notifications they send.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.49.0</strong> - 1/11/2022
                      </p>
                      <ul>
                          <li>Added ability to add hyperlinks to announcements.</li>
                          <li>Can now filter items under "my assignments" by ToDo name.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.48.0</strong> - 11/10/2021
                      </p>
                      <ul>
                          <li>My Assignments page now has "Past Due Assignments" tab for admins. This tab will show all assignments which have not been completed and are past due.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.47.0</strong> - 10/6/2021
                      </p>
                      <ul>
                          <li>My Assignments page now has "All Assignments" tab for admins.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.46.0</strong> - 9/21/2021
                      </p>
                      <ul>
                          <li>ToDo report now has the option to include todo submission information.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.45.0</strong> - 8/18/2021
                      </p>
                      <ul>
                          <li>Adjusted the sorting on assignments ready for review.</li>
                          <li>Added the assignment reviewer name to the assignment page.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.44.0</strong> - 8/12/2021
                      </p>
                      <ul>
                          <li>Added ability for administrators to send a password reset email to a user.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.43.0</strong> - 8/11/2021
                      </p>
                      <ul>
                          <li>Added ability for administrators to view all resources.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.42.0</strong> - 8/3/2021
                      </p>
                      <ul>
                          <li>Removed completable by admin option on assignment template setup.</li>
                          <li>Split completable by reviewer into two options on assignment template setup: assignment completable by reviewer and todos completable by reviewer.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.41.0</strong> - 7/30/2021
                      </p>
                      <ul>
                          <li>Inactive users are now filtered out of auto-generated groups.</li>
                          <li>Inactive/withdrawn users now hidden by default on the user's list.</li>
                          <li>Inactive/withdrawn no longer show up in a mentor's mentee list.</li>
                          <li>Adjusted the ordering of contacts on contact screen so mentor shows at the top.</li>
                          <li>No longer showing optional assignments on my assignments pages by default.</li>
                          <li>Fixed a bug where todos wit comments could not be deleted.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.40.0</strong> - 7/29/2021
                      </p>
                      <ul>
                          <li>Removed Best Time to Contact as a field option from the user's profile.</li>
                          <li>Adjusted the indentions of ordered and unordered lists to display properly.</li>
                          <li>Teaching Locations will not show on the user's profile as long as they are assigned as a school.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.39.0</strong> - 7/16/2021
                      </p>
                      <ul>
                          <li>Added archived filter to assignment and todo status reports.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.38.0</strong> - 7/7/2021
                      </p>
                      <ul>
                          <li>Assignments can now be marked as optional - these assignments do not show up on mentoring gateway and send fewer notifications.</li>
                          <li>Resource categories now have "hide from non admin" option, which hides them from the reosurce listing from non admins but still makes them accessible by direct link.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.37.2</strong> - 6/28/2021
                      </p>
                      <ul>
                          <li>Adjusted the sorting of assignment todos to be by date then by todo name.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.37.1</strong> - 5/25/2021
                      </p>
                      <ul>
                          <li>
                              Fixed a bug where todos/assignments created with past due dates would send an upcoming item due
                              notification.
                          </li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.37.0</strong> - 5/6/2021
                      </p>
                      <ul>
                          <li>A start date can now be set on assignment todos.</li>
                          <li>
                              Fixed a bug where submitted todos would still show as needing to be submitted on the mentoring
                              gateway.
                          </li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.36.0</strong> - 4/26/2021
                      </p>
                      <ul>
                          <li>Assignments with closed todos can now be submitted.</li>
                          <li>Added column to admin assignments page indicating if all assignees have completed assignment.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.35.0</strong> - 4/16/2021
                      </p>
                      <ul>
                          <li>Added a 7 day notification for assignments due dates.</li>
                          <li>Enhanced the upcoming work items portion of the mentoring gateway to be more informative.</li>
                          <li>
                              Added additional information about if an assignment is fully complete to the admin assignee
                              list.
                          </li>
                          <li>Fixed an issue with a notification about assignment todos being completed.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.34.0</strong> - 4/8/2021
                      </p>
                      <ul>
                          <li>Added an assignment report.</li>
                          <li>Fixed a bug with user export where filtering was not being obeyed.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.33.0</strong> - 3/28/2021
                      </p>
                      <ul>
                          <li>Added assignment completed and submitted date to the user assignment page.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.32.0</strong> - 3/22/2021
                      </p>
                      <ul>
                          <li>
                              Administrators of an organization will now get notifications when users change their profile
                              info.
                          </li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.31.0</strong> - 3/12/2021
                      </p>
                      <ul>
                          <li>Users can now edit additional information on their profile.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.30.0</strong> - 3/5/2021
                      </p>
                      <ul>
                          <li>Consultants can neow view their community members' profiles.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.29.0</strong> - 3/3/2021
                      </p>
                      <ul>
                          <li>
                              Added new contact page for users to contact people above them in the heirarchy through the
                              system.
                          </li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.28.0</strong> - 3/1/2021
                      </p>
                      <ul>
                          <li>Added additional filter to include closed todos on todo status report.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.27.0</strong> - 2/23/2021
                      </p>
                      <ul>
                          <li>Added additional information to user's profile pages.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.26.0</strong> - 2/15/2021
                      </p>
                      <ul>
                          <li>Added user export under Admin --> Users.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.25.0</strong> - 2/8/2021
                      </p>
                      <ul>
                          <li>Added ability to create assignments where todos auto-close on their due dates.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.24.0</strong> - 2/3/2021
                      </p>
                      <ul>
                          <li>Added ability for users to submit feedback.</li>
                          <li>Individual group members can now be sent notifications.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.23.0</strong> - 2/1/2021
                      </p>
                      <ul>
                          <li>Added completed/submitted by to the todo status report.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.22.0</strong> - 1/29/2021
                      </p>
                      <ul>
                          <li>Added assignee email to the todo status report.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.21.0</strong> - 1/27/2021
                      </p>
                      <ul>
                          <li>Added additional filtering options to admin assignments listing.</li>
                          <li>Consultants can now make announcements to their community.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.20.0</strong> - 1/25/2021
                      </p>
                      <ul>
                          <li>Added ability to set participants as "withdrawan" in the system.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.19.0</strong> - 1/22/2021
                      </p>
                      <ul>
                          <li>Added ability for consultants to send individual notifications to their community members.</li>
                          <li>Now showing role on group/community grids.</li>
                          <li>Added ability to filter a group notification to just mentors or mentees in the group.</li>
                          <li>Added the forum integration for communities.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.18.0</strong> - 1/21/2021
                      </p>
                      <ul>
                          <li>Added reviewer and assignee name to assignment submitted/completed notifications.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.17.0</strong> - 1/13/2021
                      </p>
                      <ul>
                          <li>
                              Added additional notifications for when assignment todos are all completed, and when an overall
                              assignment is completed.
                          </li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.16.0</strong> - 1/5/2021
                      </p>
                      <ul>
                          <li>Added additional filters to assignment/todo report.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.15.0</strong> - 12/21/2020
                      </p>
                      <ul>
                          <li>Added mark all as read button to my notifications page.</li>
                          <li>Gave admins ability to complete todos out of order.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.14.0</strong> - 12/17/2020
                      </p>
                      <ul>
                          <li>Updated assignment cards to better visual layout.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.13.0</strong> - 12/09/2020
                      </p>
                      <ul>
                          <li>
                              Todo report date selection now takes into account both assignment due dates and todo due dates.
                          </li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.12.0</strong> - 12/03/2020
                      </p>
                      <ul>
                          <li>Assignment cards on the "My Assignments" page are now ordered by next todo item due date.</li>
                          <li>Added next todo item due date to display on all assignment cards.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.11.0</strong> - 12/02/2020
                      </p>
                      <ul>
                          <li>Assignments can now be created with assignees' mentors set as reviewer.</li>
                          <li>Added feedback to the assignment todo report export.</li>
                          <li>Made assignment feedback comments rich text.</li>
                          <li>
                              Users now get todos on homepage for assignment todos ready for reviewe that they are reviewer
                              for.
                          </li>
                          <li>
                              Completable by admin and completable by reviwer are now two seperate selections on assignment
                              setup.
                          </li>
                          <li>Small bugfixes/quality of life improvements with assignmetn submission.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.10.0</strong> - 11/25/2020
                      </p>
                      <ul>
                          <li>On completed assignment cards, completed date now shows instead of due date.</li>
                          <li>Added more options for navigating between assignees' todos.</li>
                          <li>Finished initial implementation of assignment notifications.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.9.0</strong> - 11/22/2020
                      </p>
                      <ul>
                          <li>Added a reports section to the system and a Todo Status Report.</li>
                          <li>Admins now have the ability to "un-complete" assignments and todos.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.8.0</strong> - 11/17/2020
                      </p>
                      <ul>
                          <li>Fixed an issue where anyone could edit calendar items created by admins.</li>
                          <li>Now showing todos that have been submitted/completed on all assignment cards.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.7.0</strong> - 11/13/2020
                      </p>
                      <ul>
                          <li>Update sorting in assignees side drawer.</li>
                          <li>Added number of todos submitted/completed to "My Assignments" display.</li>
                          <li>Updated order of todos under assignments to be by due date descending.</li>
                          <li>
                              Fixed an issue where bulleted and numbered lists would not show correctly in assignment
                              descriptions.
                          </li>
                          <li>Fixed an issue where a duplicated todo could not have the current todo as it's pre-requisite.</li>
                          <li>Fixed an issue where copying an assignment did not copy todo pre-requisites.</li>
                          <li>Behind the scenes work preparing for assignment notifications.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.6.0</strong> - 11/06/2020
                      </p>
                      <ul>
                          <li>Flex field labels can now be modified under Admin --> Config.</li>
                          <li>Custom sidenav links can now be set under Admin --> Config.</li>
                          <li>A persistent filter can now be used on the admin groups page to hide mentee groups.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.5.0</strong> - 10/30/2020
                      </p>
                      <ul>
                          <li>Assignee name will now show up under todos in addition to under assignments.</li>
                          <li>Archived assignment todos will now fall off of user's assigned todo list.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.4.0</strong> - 10/29/2020
                      </p>
                      <ul>
                          <li>Now sorting assignees side-drawer under manage assignments by ready for review then by alpha.</li>
                          <li>
                              Added tabs under "My Assignments" page for mentor's mentees' assignments and consultant's
                              community members' assignments.
                          </li>
                          <li>Bugfixes and optimizations with assignments.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.3.0</strong> - 10/25/2020
                      </p>
                      <ul>
                          <li>ToDos under assignments can now be duplicated.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.2.0</strong> - 10/21/2020
                      </p>
                      <ul>
                          <li>Now allowing admins to upload resources on behalf of other users.</li>
                          <li>Assignments can now be archived.</li>
                          <li>Edit all user data page now has a groups tab.</li>
                          <li>Added best time to contact/contact preference for edit to the user profile page.</li>
                          <li>Fixed a bug with setting profile pictures from the user profile page.</li>
                          <li>Consultant role should now be functional.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-10">
                      <p class="mb-2">
                          <strong>1.1.1</strong> - 10/19/2020
                      </p>
                      <ul>
                          <li>Made group member listings display in ascending name order.</li>
                          <li>Restored ability to set hyperlinks from editor for assignments and todos.</li>
                          <li>Added validation to ensure a user cannot be added to the same group twice.</li>
                      </ul>
                  </div>
                  <div class=" text-xl pb-5">
                      <p class="mb-2">
                          <strong>1.1.0</strong> - 10/16/2020
                      </p>
                      <ul>
                          <li>
                              Added the ability for admins to send a welcome email with a randomly generated password to new
                              users when they are created.
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    parent: true,
  };
</script>